import React, { Component } from "react";

class Image extends Component {
  handle_error(e) {
    e.target.onerror = null;
    e.target.src = require(`../../assets/images/${
      this.props.isProfile ? "ic_avatar.png" : "logo_white.svg"
    }`).default;
    if (this.props.extraClassName) {
      var classArrey = this.props.extraClassName.split(" ");
      classArrey.map((className, c) => e.target.classList.add(className));
    } else {
      e.target.classList.add("rounded-2", "p-2", "bg-color-main", "w-100");
    }
    if (this.props.isProfile) {
      e.target.classList.remove("rounded-circle", "rounded28");
    }
    e.target.classList.remove("img-cover");
  }
  render() {
    return (
      <img
        style={this.props.imageStyle}
        alt={this.props.imageAlt && this.props.imageAlt}
        height={this.props.imageHeight && this.props.imageHeight}
        width={this.props.imageWidth && this.props.imageWidth}
        onError={(e) => {
          this.handle_error(e);
        }}
        src={
          this.props.imageUri
            ? this.props.imageUri
            : require(`../../assets/images/${
                this.props.isProfile ? "ic_avatar.png" : "logo_white.svg"
              }`).default
        }
        className={
          !this.props.imageUri && this.props.extraClassName
            ? this.props.extraClassName
            : !this.props.extraClassName && !this.props.imageUri
            ? "rounded-2 p-2 bg-color-main w-100"
            : this.props.imgClassName && this.props.imgClassName
        }
      />
    );
  }
}

export default Image;
